export default __webpack_public_path__ + "static/media/PH_Bills.88d27bf0.svg";